module.exports = __webpack_public_path__ + "img/desktop4.d3fd4e1c.svg";